$(document).ready(function(){
  $('.itgv--list__slider__6').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 6,
    prevArrow:"<button type='button' class='slick-prev pull-left'><svg width='48' height='49' viewBox='0 0 48 49' fill='none' xmlns='http://www.w3.org/2000/svg'><g id='chevron-left'><path id='Vector' d='M30 36.5L18 24.5L30 12.5' stroke='#3F434A' stroke-width='0.83' stroke-linecap='round' stroke-linejoin='round'/></g></svg></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><svg width='48' height='49' viewBox='0 0 48 49' fill='none' xmlns='http://www.w3.org/2000/svg'><g id='chevron-left'><path id='Vector' d='M18 36.5L30 24.5L18 12.5' stroke='#3F434A' stroke-width='0.83' stroke-linecap='round' stroke-linejoin='round'/></g></svg></button>",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  }); 



  $('.itgv--list__slider__4').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    prevArrow:"<button type='button' class='slick-prev pull-left'><svg width='48' height='49' viewBox='0 0 48 49' fill='none' xmlns='http://www.w3.org/2000/svg'><g id='chevron-left'><path id='Vector' d='M30 36.5L18 24.5L30 12.5' stroke='#3F434A' stroke-width='0.83' stroke-linecap='round' stroke-linejoin='round'/></g></svg></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><svg width='48' height='49' viewBox='0 0 48 49' fill='none' xmlns='http://www.w3.org/2000/svg'><g id='chevron-left'><path id='Vector' d='M18 36.5L30 24.5L18 12.5' stroke='#3F434A' stroke-width='0.83' stroke-linecap='round' stroke-linejoin='round'/></g></svg></button>",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });

  
/*####################################################################*/

    function ProtectionAdd() {
      var protection_selected = 'protection_selected';
       $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data:    
             items = {
            "id": 43213446578354,
            "quantity": 1
          }, 
            dataType: 'json',
            success: function() {
              window.location.reload();
              localStorage.setItem('protection_selected', protection_selected);
              $.getJSON('/cart.js',function(cart){
                // $('.cart-count-bubble > span ').text(cart.item_count);              
              });
            }
       });
    }
    function ProtectionRemove() {
      var protection_selected = 'protection_selected';
        $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data:    
             items = {
            "id": 43213446578354,
            "quantity": 0
          }, 
            success: function() { 
              window.location.reload();
              $.getJSON('/cart.js',function(cart){
                // $('.cart-count-bubble > span ').text(cart.item_count);              
              });
              localStorage.removeItem('protection_selected');
            }
       });
    }
    function ProtectionUpdate() {
      var protection_selected = 'protection_selected';
        $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data:    
             items = {
            "id": 43213446578354,
            "quantity": 1
          }, 
            dataType: 'json',
            success: function() { 
              window.location.reload();
              $.getJSON('/cart.js',function(cart){
                // $('.cart-count-bubble > span ').text(cart.item_count);              
              });
              //localStorage.removeItem('protection_selected');
            }
       });
    }
  
    if(localStorage.getItem('protection_selected')) {
      $('.itgv--shipping__protection #protection').prop('checked', 'checked');
    }

    $(document).on('change', '.itgv--shipping__protection #protection', function() {
      if($(this).prop("checked") == true){
        // alert("Checkbox is checked.");
       ProtectionAdd();
      } else {
        ProtectionRemove();
      }
    });

    $(document).on('click', '.SwymRemoveItem', function(e) {
      e.preventDefault();
      localStorage.removeItem('protection_selected');
      ProtectionRemove();
    });
    
    var valueProtectionQty = $(document).find('.SwymShippingProduct').find('.cart-item__quantity .quantity-selector__input').val();
    if (valueProtectionQty > 1 ) {
        ProtectionUpdate();
    }
  
    $('.cart-subtotal').on('DOMSubtreeModified', function() {
      console.log('changed');
      var valueProtectionQty = $(document).find('.SwymShippingProduct').find('.cart-item__quantity .quantity-selector__input').val();
      if (valueProtectionQty > 1 ) {
          ProtectionUpdate();
      }
        $.getJSON('/cart.js',function(cart) {
          if (cart.item_count == 1) {
            for(var i=0; i < cart.items.length; i++) {
              if (cart.items[i].variant_id == "43213446578354") {
                ProtectionRemove();
              }
              console.log(cart.items[i]);
            }
          }
        });
    });
  
    $.getJSON('/cart.js',function(cart) {
      if (cart.item_count == 1) {
        for(var i=0; i < cart.items.length; i++) {
          if (cart.items[i].variant_id == "43213446578354") {
            ProtectionRemove();
          }
          console.log(cart.items[i]);
        }
      }
    });
    
});






